import { rhythms } from './rhythms';
import { blocks } from './blocks';
import { stPatterns } from './stPatterns';

export const categories = [
  { id: 'all', label: 'Alle Befunde' },
  { id: 'rhythm', label: 'Rhythmus & Extrasystolen' },
  { id: 'conduction', label: 'Schenkel- & AV-Blöcke' },
  { id: 'st', label: 'ST-Veränderungen' },
  { id: 'emergency', label: 'Notfallrhythmen' }
];

const emergencies = [
  {
    id: 'vt', title: 'Ventrikuläre Tachykardie', short: 'Ventrikuläre Tachykardie', category: 'emergency', tag: 'Breitkomplextachykardie', duration: 6,
    summary: 'Hier ein monomorphes Lehrbeispiel einer schnellen Kammererregung.',
    focus: [{ lead: 'II', note: 'Schnelle Folge breiter, gleichförmiger Komplexe' }, { lead: 'V1', note: 'Zusätzliche Ableitung zur Morphologiebeurteilung' }],
    features: ['Tachykardie mit breiten QRS-Komplexen, meist ≥ 120 ms.', 'Monomorph: gleiche QRS-Form; polymorphe Formen sehen anders aus.', 'AV-Dissoziation, Capture- oder Fusionsschläge können den ventrikulären Ursprung stützen.'],
    mnemonic: 'Breit und schnell: VT ernsthaft in Betracht ziehen.',
    caution: 'SVT mit Aberranz und Artefakte können ähnlich aussehen. VT kann mit oder ohne Puls auftreten. Bei Instabilität/fehlendem Puls sofort nach Notfallstandard handeln – die Referenz darf keine Versorgung verzögern.', sources: ['vt']
  },
  {
    id: 'vf', title: 'Kammerflimmern', short: 'Kammerflimmern', category: 'emergency', tag: 'Reanimationsrhythmus', duration: 6, rhythmOnly: true,
    summary: 'Chaotische Kammeraktivität ohne geordnete P-, QRS- oder T-Komplexe.',
    focus: [{ lead: 'II', note: 'Unregelmäßige Wellen wechselnder Höhe und Form' }],
    features: ['Keine erkennbaren geordneten QRS-Komplexe.', 'Unregelmäßige, wechselnde Amplituden; grobes oder feines Flimmern.', 'Keine effektive Kammerkontraktion; rasche klinische Beurteilung erforderlich.'],
    mnemonic: 'Chaos statt Komplexe.',
    caution: 'Artefakte können Flimmern vortäuschen; feines Flimmern kann wie Asystolie wirken. Patient und Signalqualität sofort prüfen. Bei Kreislaufstillstand Reanimation/Defibrillation nach gültigem Algorithmus, nicht erst ein 12-Kanal-EKG abwarten.', sources: ['vf']
  }
];

export const ekgPatterns = [...rhythms, ...blocks, ...stPatterns, ...emergencies];
export const standardLeads = ['I', 'aVR', 'V1', 'V4', 'II', 'aVL', 'V2', 'V5', 'III', 'aVF', 'V3', 'V6'];
export const getPattern = id => ekgPatterns.find(pattern => pattern.id === id);

const base = 'https://litfl.com/';
export const sources = {
  library: { label: 'LITFL · ECG Library', url: `${base}ecg-library/diagnosis/` },
  rbbb: { label: 'LITFL · Right Bundle Branch Block', url: `${base}right-bundle-branch-block-rbbb-ecg-library/` },
  lbbb: { label: 'LITFL · Left Bundle Branch Block', url: `${base}left-bundle-branch-block-lbbb-ecg-library/` },
  sgarbossa: { label: 'LITFL · Sgarbossa Criteria', url: `${base}sgarbossa-criteria-ecg-library/` },
  posterior: { label: 'LITFL · Posterior Myocardial Infarction', url: `${base}posterior-myocardial-infarction-ecg-library/` },
  inferior: { label: 'LITFL · Inferior STEMI', url: `${base}inferior-stemi-ecg-library/` },
  anterior: { label: 'LITFL · Anterior Myocardial Infarction', url: `${base}anterior-myocardial-infarction-ecg-library/` },
  mobitz1: { label: 'LITFL · Mobitz I / Wenckebach', url: `${base}av-block-2nd-degree-mobitz-i-wenckebach-phenomenon/` },
  mobitz2: { label: 'LITFL · Mobitz II', url: `${base}av-block-2nd-degree-mobitz-ii-hay-block/` },
  af: { label: 'LITFL · Atrial Fibrillation', url: `${base}atrial-fibrillation-ecg-library/` },
  flutter: { label: 'LITFL · Atrial Flutter', url: `${base}atrial-flutter-ecg-library/` },
  pac: { label: 'LITFL · Premature Atrial Complex', url: `${base}premature-atrial-complex-pac/` },
  vt: { label: 'LITFL · Monomorphic VT', url: `${base}ventricular-tachycardia-monomorphic-ecg-library/` },
  vf: { label: 'LITFL · Ventricular Fibrillation', url: `${base}ventricular-fibrillation-vf-ecg-library/` }
};